<template>
    <div class="container">
            <div class="div store-wrapper" v-if="favorites_list && favorites_list.length">
                <div class="store-item"  v-for="(item, index) in favorites_list" v-bind:key="item.fav_id" @click="goStore(item.store_id)">
            		<div class="div p-img">
            			<img class="img collection-img" v-bind:src="item.store_avatar_url"/>
            		</div>
                    <div class="div store_name">{{ item.store_name }}</div>
            		<div class="div del-btn" @click.stop="delFavoriteStore(item.fav_id)">
            			<div class="iconfont">&#xe64d;</div>
            			<div class="explain" >取消收藏</div>
            		</div>
                </div>
            </div>
            <empty-record v-else-if="favorites_list && !favorites_list.length"></empty-record>
    </div>
</template>
<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getFavoriteStoreList, delFavoriteStore } from '../../../api/memberFavorite'
import flexLine from '../../flexLine'
export default {
  components:{
    flexLine,
    EmptyRecord
  },
  name: 'MemberFavoriteStore',
  data () {
    return {
      favorites_list: false
    }
  },
  created: function () {
    this.getFavoriteStoreList()
  },

  methods: {
    delFavoriteStore (favId) {
      MessageBox.confirm('是否要取消收藏此店铺？').then(action => {
    	delFavoriteStore(favId).then(res => {
    		if (res) {
    		  this.getFavoriteStoreList()
    		}
    	}).catch(function (error) {
    	  Toast(error.message)
    	})
      })
    },
    getFavoriteStoreList () {
      Indicator.open()
      getFavoriteStoreList(this.page, {}).then(res => {
        Indicator.close()
        this.favorites_list = res.result.favorites_list
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
	goStore (store_id) {
	  this.$router.push({ 'name': 'HomeStoredetail', 'query': { 'id': store_id } })
	}
  }
}
</script>
<style lang="scss" scoped>
.store-wrapper{background: #fff;border-radius: .5rem;padding:0 $pageSpace 2rem;}
.store-wrapper .store-item{height:3rem;width:100%;padding: .8rem 0;border-bottom: 1px dashed #DBDADF;display: flex;align-items: center;}
.store-wrapper .store-item .p-img{padding:0.25rem 0;}
.store-wrapper .store-item .p-img .img{width:3rem;height:3rem;border-radius:.5rem}
.store-wrapper .store-item .store_name{color: #333;font-size: .8rem;margin-left: 1rem;width: 40%;overflow: hidden;white-space: nowrap}
.store-wrapper .store-item .del-btn{margin-left: auto;text-align: center;margin-right: 1rem;}
.store-wrapper .store-item .del-btn .iconfont{font-size: 1.4rem;color: $primaryColor;}
.store-wrapper .store-item .del-btn .explain{font-size: .7rem;color: #999;}
</style>